import OrganizationService from 'src/services/organization'
import MockLocationLogService from '@/services/mockLocationLog'
import { cachePhotoFullQuality, parsePhotoFullQuality } from '@/utils/photoQuality'

export default {
  // TKT-2149: descarga del reporte de ubicación estricta (Excel por rango de fechas).
  exportMockLocationReport (payload) {
    return MockLocationLogService.exportReport(payload)
  },
  fetch () {
    const promise = OrganizationService.fetch()

    promise.then(data => {
        this.organizations = data.data
      })
      .catch(err => {
        console.error(err)
      })

    return promise
  },
  fetchPaginated (payload = {}) {
    const page = payload.page || 1
    if (page === 1 && this.newOrganizations.length > 0) {
      this.organizations = []
      this.status = 'loading'
    }

    const promise = OrganizationService.fetchPaginated(payload)
    promise
      .then(data => {
        if (data.data.length > 0) {
          if (Array.isArray(data.data)) {
            const newData = data.data.filter(org => !this.organizations.find(o => o.id === org.id))
            this.organizations = [...this.organizations, ...newData]
          }
          this.pagination = {
            total: data.total,
            count: data.to,
            per_page: data.per_page,
            current_page: data.current_page,
            total_pages: data.last_page
          }
        }
        this.status = 'success'
      })
      .catch(err => {
        console.error(err)
      })

    return promise
  },
  async fetchGeneralSettings (payload) {
    const data = await OrganizationService.getGeneralSettings(payload.organization_id, payload.type)

    try {
      if (data.data) {
        const settings = JSON.parse(data.data.data)
        this.settings[payload.type] = settings
        if (payload.type === 'extra_settings') {
          cachePhotoFullQuality(payload.organization_id, parsePhotoFullQuality(settings))
        }
      }
    } catch (error) {
      console.error(error)
    }

    return data
  },
  async fetchEndMailShare (organizationId) {
    try {
      const response = await this.fetchGeneralSettings({ organization_id: organizationId, type: 'extra_settings' })
      if (response.data === null) return true

      const dataString = response.data.data
      if (typeof dataString === 'string' && (dataString.startsWith('[') || dataString.startsWith('{'))) {
        return JSON.parse(dataString)[0]?.end_mail_share || false
      }
      console.warn('[fetchEndMailShare] extra_settings no es JSON valido, se desactiva el correo:', dataString)
      return false
    } catch (error) {
      console.error('[fetchEndMailShare]', error)
      return false
    }
  },
  fetchSettings (organization_id) {
    const settings = {
      form_goals: []
    }
    const settingsType = [
      'alt_franchise_name',
      'action_plan_priorities',
      'action_plan_reminder',
      'ap_categories',
      'ap_categories2',
      'agenda_values',
      'sprint_window',
      'reports',
      'critical_points_semaphore',
      'form_categories',
      'location_group_names',
      'rol_location_responsable',
      'score_scale'
    ]
    let cnt = 0

    settingsType.map(type => {
      const franchisePromise = OrganizationService.getGeneralSettings(organization_id, type)

      franchisePromise.then(data => {
        cnt++
        if (type === 'alt_franchise_name') {
          settings[type] = data.data.data
        } else if (type === 'sprint_window') {
          let windowsArr = []
          data && data.data && data.data.data && data.data.data && JSON.parse(data.data.data).map(obj => {
            windowsArr.push(JSON.parse(obj))
          })
          settings[type] = windowsArr
        } else {
          if (data.data) {
            settings[type] = JSON.parse(data.data.data)
          } else {
            settings[type] = this.settings[type]
            if (type === 'critical_points_semaphore') {
              settings[type] = {}
            }
          }
        }
        if (cnt === settingsType.length) {
          this.status = true
          this.settings = settings
        }
      }).catch((err) => {
        console.error('TYPE', type, err)
        this.status = true
      })
    })
    return 'promise'
  },
  saveSettings (payload) {
    this.status = false
    const promiseData = {
      organization_id: payload.organization_id,
      type: payload.type
    }

    if (payload.type === 'alt_franchise_name') promiseData.data = payload.data
    else promiseData.data = JSON.stringify(payload.data)

    const promise = OrganizationService.configureSettings(payload.organization_id, promiseData)

    promise.then(() => {
      this.status = true
    }).catch(err => {
      console.error('ERROR', err)
    })
    return promise
  },
  addAPCategory (payload) {
    const promise = OrganizationService.addAPCategory(payload.organization_id, payload.category.trim(), payload.type)
    promise.then(result => {
      if (result.data) {
        if (result.data.data) {
          const parsedData = JSON.parse(result.data.data).pop()
          if (payload.type === 'ap_categories') this.settings.ap_categories.push(parsedData)
          else this.settings.ap_categories2.push(parsedData)
        }
      }
    }).catch(err => {
      console.error(err)
    })
    return promise
  },
  deleteAPCategory (payload) {
    const promise = OrganizationService.deleteAPCategory(payload.organization_id, payload.category, payload.type)
    promise.then(result => {
      if (result.data && result.data.data) {
        const parsedData = JSON.parse(result.data.data)
        if (payload.type === 'ap_categories') this.settings.ap_categories = parsedData
        else this.settings.ap_categories2 = parsedData
      }
    }).catch(err => {
      console.error('ERR:', err)
    })
    return promise
  },
  editAPCategory (payload) {
    const promise = OrganizationService.changeCategory(payload.organization_id, payload.category, payload.newCategory, payload.type)

    promise.then(result => {
      if (result.data && result.data.data) {
        const parsedData = JSON.parse(result.data.data)
        if (payload.type === 'ap_categories') this.settings.ap_categories = parsedData
        else this.settings.ap_categories2 = parsedData
      }
    }).catch(err => {
      console.error(err)
    })
    return promise
  },
  updateLocationsResponsableRole (roleId) {
    this.settings.rol_location_responsable = roleId
  },
  updateFormCategory (payload) {
    const promise = OrganizationService.updateFormCategory(payload.organization_id, payload.oldCategory, payload.newCategory)
    
    promise.then(result => {
      if (result.data) {
        if (result.data.data) this.settings.form_categories = JSON.parse(result.data.data)
      }
    })
    return promise
  },
  deleteFormCategory (payload) {
    const promise = OrganizationService.deleteFormCategory(payload.organization_id, payload.category)
    
    promise.then(result => {
      if (result.data) {
        if (result.data.data) this.settings.form_categories = JSON.parse(result.data.data)
      }
    })
    return promise
  },
  updateItemResponsability (payload) {
    const promise = OrganizationService.updateItemResponsability(payload.organization_id, payload.oldResponsability, payload.newResponsability)
    
    promise.then(result => {
      if (result.data) {
        if (result.data.data) this.settings.item_responsabilities = JSON.parse(result.data.data)
      }
    })
    return promise
  },
  deleteItemResponsability (payload) {
    const promise = OrganizationService.deleteItemResponsability(payload.organization_id, payload.responsability)
    
    promise.then(result => {
      if (result.data) {
        if (result.data.data) this.settings.item_responsabilities = JSON.parse(result.data.data)
      }
    })
    return promise
  },
  updateItemLeadership (payload) {
    const promise = OrganizationService.updateItemLeadership(payload.organization_id, payload.oldLeadership, payload.newLeadership)
    
    promise.then(result => {
      if (result.data) {
        if (result.data.data) this.settings.item_leaderships = JSON.parse(result.data.data)
      }
    })
    return promise
  },
  deleteItemLeadership (payload) {
    const promise = OrganizationService.deleteItemLeadership(payload.organization_id, payload.leadership)
    
    promise.then(result => {
      if (result.data) {
        if (result.data.data) this.settings.item_leaderships = JSON.parse(result.data.data)
      }
    })
    return promise
  },
  addSprintWindow (payload) {
    const promise = OrganizationService.addSprintWindow(payload.organization_id, JSON.stringify(payload.sprint_window))
    
    promise.then(result => {
      if (result.data) {
        if (result.data.data) {
          let windowsArr = []
          JSON.parse(result.data.data).map(obj => {
            windowsArr.push(JSON.parse(obj))
          })
          this.settings.sprint_window.push(windowsArr.pop())
        }
      }
    }).catch(err => {
      console.error(err)
    })
  },
  deleteSprintWindow (payload) {
    const promise = OrganizationService.deleteSprintWindow(payload.organization_id, payload.category)
    
    promise.then(result => {
      if (result.data) {
        if (result.data.data) {
          let windowsArr = []
          JSON.parse(result.data.data).map(obj => {
            windowsArr.push(JSON.parse(obj))
          })
          this.settings.sprint_window = windowsArr
        }
      }
    }).catch(err => {
      console.error('ERR:', err)
    })
  },
  getSectors () {
    const promise = OrganizationService.getSectors()

    promise.then(result => {
      this.sectors = result
    })

    return promise
  },
  obtainedOrganizations () {
    const promise = OrganizationService.fetchPaginated()

    promise.then(data => {
      this.newOrganizations = data.data
    })

    return promise
  },
  obtainedOrganizationsToDropdown () {
    const promise = OrganizationService.getOrganizationstoDropdown()

    promise.then(data => {
      this.newOrganizations = data
    })

    return promise
  },
  obtainedFranchisesToDropdown (id) {
    const promise = OrganizationService.getFranchisestoDropdown(id)

    promise.then(data => {
      this.newFranchises = data
    })

    return promise
  },
  obtainedUserByFranchises (id) {
    const promise = OrganizationService.getUserByFranchises(id)

    promise.then(data => {
      this.userByFranchises = data
    })

    return promise
  },
  obtainedUserByOrganizations (id) {
    const promise = OrganizationService.getUserByOrganizations(id)

    promise.then(data => {
      this.userByFranchises = data
    })

    return promise
  },
  changeStatus (payload) {
    const promise = OrganizationService.updateStatus(payload)

    promise.catch(err => console.error(err))
  },
  obtainedEnabledFranchise (id) {
    const promise = OrganizationService.getEnableFranchise(id)
    promise.then(data => {
      this.enabledFranchise = data
    })
  },
  enabledUserFranchises (payload) {
    const promise = OrganizationService.updateEnabledUserFranchises(payload)
    promise.catch(err => console.error(err))
  },
  clearOrganizations () {
    this.organizations = []
  },
  setCriticalPointsSemaphore (payload) {
    const val = this.settings['critical_points_semaphore'][payload.form_id] || {
      green: 0,
      amber: 0,
      red: 0
    }

    this.settings['critical_points_semaphore'][payload.form_id] = val
    this.settings['critical_points_semaphore'][payload.form_id][payload.color] = payload.val
  },
  getCategoryAreas (payload) {
    return OrganizationService.getCategoryAreas(payload.organization_id, payload.category)
  },
  saveCategoryAreas (payload) {
    return OrganizationService.saveCategoryAreas(payload.organization_id, payload.category, payload.areas)
  },
  getAllCategoryAreas (payload) {
    return OrganizationService.getAllCategoryAreas(payload.organization_id)
  },
  getAreasForCategories (payload) {
    return OrganizationService.getAreasForCategories(payload.organization_id, payload.categories)
  }
}
